import { Logger } from '@frontend/logger';

function handleProtocolLaunch() {
    const urlParams = new URLSearchParams(window.location.search);
    const action = urlParams.get('action');
    Logger.log('Protocol launched with action:', action);
    if (action) {
        // Parse the action - it contains everything after "web+telloport_kiosk://"
        // Should only be used for navigation purposes
        Logger.log('Received action:', action);
        window.location.href = '/' + action; // Redirect to the appropriate page
    }
}

window.addEventListener('load', handleProtocolLaunch);
